const providersLang = {
  en: {
    hasRetention: "Subject to retention",
    country: "Country",
    department: "Department",
    city: "City",
    provider_insert_succesful: "The provider has saved correctly",
    provider_updated_successful: "The provider has updated correctly",
    relatedRequests: "Related requests",
    requestID: "Request ID",
    emissionDate: "Emission date",
    billSeries: "Bill series",
    billNumber: "Bill number",
    amount: "Amount",
    noData: "No data",
    generalInfo: "General information",
    previousPage: "Previous Page",
    nextPage: "Next Page",
    page: "Page",
    perPage: "per page",
    showing: "Showing",
    results: "results",
    enterName: "Enter name",
    enterNit: "Enter NIT",
    enterPhone: "Enter phone",
    enterAddress: "Enter address",
    enterDescription: "Enter description",
    fieldLengthBetween: "Field length must be between {min} and {max} characters"
  },
  es: {
    hasRetention: "Sujeto a retención",
    country: "País",
    department: "Departamento",
    city: "Ciudad",
    provider_insert_succesful: "El proveedor se ha guardado correctamente",
    provider_updated_successful: "El proveedor se ha actualizado correctamente",
    relatedRequests: "Solicitudes relacionadas",
    requestID: "ID de solicitud",
    emissionDate: "Fecha de emisión",
    billSeries: "Serie de factura",
    billNumber: "Número de factura",
    amount: "Monto",
    noData: "No hay datos disponibles",
    generalInfo: "Información general",
    previousPage: "Página Anterior",
    nextPage: "Página Siguiente",
    page: "Página",
    perPage: "por página",
    showing: "Mostrando",
    results: "resultados",
    enterName: "Ingrese nombre",
    enterNit: "Ingrese NIT",
    enterPhone: "Ingrese teléfono",
    enterAddress: "Ingrese dirección",
    enterDescription: "Ingrese descripción",
    fieldLengthBetween: "La longitud del campo debe estar entre {min} y {max} caracteres"
  },
};

export default providersLang;
